import React, { Suspense, useEffect } from 'react';
import SiderMenu from '../../components/Menu';
import Loading from '../../components/Loading';
import ReactWaterMark from 'react-watermark-component';
import Header from '../../components/Head';
import {Route, Switch} from "react-router-dom";
import {contentRoutes, CASEPOOLURL, DETAILURL} from "../routes";
import './index.less';
import { useWebsocket } from "@utils/hooks";
import Logs from "../../utils/Logs";


// 首页
const Main = () => {

  const text = sessionStorage.getItem('user');
  const beginAlarm = function() { console.log('start alarm'); };
  const options = {
    chunkWidth: 300,
    chunkHeight: 200,
    textAlign: 'left',
    textBaseline: 'bottom',
    globalAlpha: 0.3,
    font: '14px Microsoft Yahei',
    rotateAngle: 0.34,
    fillStyle: '#666'
  }



  return (
    <div className="main">
      <Loading />
      <SiderMenu casepoolUrl={CASEPOOLURL} />
      <div className="right-frame">
        <Header casepoolUrl={CASEPOOLURL} />
        <ReactWaterMark
          waterMarkText={text}
          openSecurityDefense
          securityAlarm={beginAlarm}
          options={options}
        >
          <div className="main-content">
            <Suspense fallback={<div>Loading...</div>}>
              <Switch>
                <Route exact path="/fagicCourt">
                  <div className='welcome'>
                    <p className="welcome-word">欢迎使用数字调解平台</p>
                  </div>
                </Route>
                {
                  contentRoutes.map(({path, Component, ...route})=>(
                    <Route
                      key={path}
                      path={path}
                    >
                      <Component detailUrl={DETAILURL} />
                    </Route>
                  ))
                }
              </Switch>
            </Suspense>
          </div>
        </ReactWaterMark>
      </div>
    </div>
  );
}
export default Main
